// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
    width: 100%;
    margin: 15px auto;
    text-align: center;
}

.card__label {
    font-size: 2.75em;
    font-weight: bold;
    padding: 25px;
}

.card__label::after {
    content: '';
    margin-top: 16px;
    display: block;
    border-bottom: 1px solid #eeeeee;
}
`, "",{"version":3,"sources":["webpack://./src/styles/card.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,gCAAgC;AACpC","sourcesContent":[".card {\n    width: 100%;\n    margin: 15px auto;\n    text-align: center;\n}\n\n.card__label {\n    font-size: 2.75em;\n    font-weight: bold;\n    padding: 25px;\n}\n\n.card__label::after {\n    content: '';\n    margin-top: 16px;\n    display: block;\n    border-bottom: 1px solid #eeeeee;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
